import {Grid} from "@material-ui/core";
import {EditProfilePrizes} from "../../../author/edit-profile/edit-profile-prizes";
import {BoxWrapper} from "../../../box-wrapper/box-wrapper";
import {StyledCheckbox} from "../../../form/checkbox";
import {StyledInput} from "../../../form/input";
import prizes from "../../../../img/prizes.png";
import {useTranslation} from "react-i18next";
import {CountryAutocomplete} from "../../../form/country-autocomplete";
import React from "react";
import {TranslateLangToLang} from "./translate-lang-to-lang";
import {
	KeyboardDatePicker, MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import styled from "styled-components";
import {Colors} from "../../../../theme/colors";

export const AddBookFormStep3: React.FC<Props> = (
	{
		handleChange,
		setFieldValue,
		values,
		errors,
		touched
	}
) => {
	const {t} = useTranslation(['publisher', 'common']);

	return (
		<Grid
			container
			direction="row"
			spacing={2}
		>
			<Grid container item sm={12} md={6} direction={'column'} spacing={2}>
				<Grid item style={{'marginTop': '-10px', 'marginBottom': '10px'}}>
					<StyledCheckbox
						id={"publishMarket"}
						name={"publishMarket"}
						onChange={handleChange}
						value={values.publishMarket}
						label={t('addBookNew.form.publishMarket')}
						tooltipInfo={t('addBookNew.form.publishMarketInfo')}
					/>
				</Grid>

				<BoxWrapper title={t('addBookNew.searchForBook')}>
					<Grid container direction={'column'} spacing={2}>
						<Grid item>
                            <CountryAutocomplete
                                values={values}
                                setFieldValue={setFieldValue}
                                fieldName={'searchPublisherCountries'}
                                label={t('addBookNew.form.searchPublisherCountries')}
                                error={!!(errors.searchPublisherCountries && touched.searchPublisherCountries)}
                            />
                        </Grid>

						<Grid item>
							<StyledCheckbox
								id={"servicesContractors"}
								name={"servicesContractors"}
								onChange={handleChange}
								value={values.servicesContractors}
								label={t('addBookNew.form.servicesContractors')}
							/>

							{values.servicesContractors &&
                                <Grid item container direction="column" style={{marginLeft: '20px'}}>
                                    <Grid item>
                                        <StyledCheckbox
                                            id={"translation"}
                                            name={"translation"}
                                            onChange={handleChange}
                                            value={values.translation}
                                            label={t('addBookNew.form.translation')}
                                        />
                                    </Grid>

									{values.translation &&
                                        <Grid item>
                                            <TranslateLangToLang
                                                values={values}
                                                handleChange={handleChange}
                                                fieldName={'langToLang'}
                                                touched={touched}
                                                errors={errors}
                                                setFieldValue={setFieldValue}
                                            />
                                        </Grid>
									}

                                    <Grid item>
                                        <StyledCheckbox
                                            id={"editors"}
                                            name={"editors"}
                                            onChange={handleChange}
                                            value={values.editors}
                                            label={t('addBookNew.form.editors')}
                                        />
                                    </Grid>

                                    <Grid item>
                                        <StyledCheckbox
                                            id={"corrector"}
                                            name={"corrector"}
                                            onChange={handleChange}
                                            value={values.corrector}
                                            label={t('addBookNew.form.corrector')}
                                        />
                                    </Grid>

                                    <Grid item>
                                        <StyledCheckbox
                                            id={"graphic"}
                                            name={"graphic"}
                                            onChange={handleChange}
                                            value={values.graphic}
                                            label={t('addBookNew.form.graphic')}
                                        />
                                    </Grid>

                                    <Grid item>
                                        <StyledCheckbox
                                            id={"reviewer"}
                                            name={"reviewer"}
                                            onChange={handleChange}
                                            value={values.reviewer}
                                            label={t('addBookNew.form.reviewer')}
                                        />
                                    </Grid>
                                </Grid>
							}
						</Grid>
					</Grid>
				</BoxWrapper>
			</Grid>

			<Grid container item sm={12} md={6} direction={'column'} spacing={2}>
				<BoxWrapper title={t('addBookNew.sellInfo')}>
					<Grid container direction={'column'} spacing={2}>
						<Grid item>
							<StyledInput
								id="numberOfBooks"
								type={'number'}
								label={t('addBookNew.form.numberOfBooks')}
								onChange={handleChange}
								value={values.numberOfBooks}
								error={errors.numberOfBooks && touched.numberOfBooks}
							/>
						</Grid>
						<Grid item>
							<StyledLabel>{t('addBookNew.form.releaseDate')}</StyledLabel>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<StyledKeyboardDatePicker
									disableToolbar
									autoOk
									variant="inline"
									inputVariant="outlined"
									format="dd/MM/yyyy"
									margin="normal"
									id="releaseDate"
									label={''}
									value={values.releaseDate}
									InputAdornmentProps={{ position: "start" }}
									onChange={(date: Date | null) => {
										setFieldValue('releaseDate', date);
									}}
									style={{'width': '100%'}}
								/>
							</MuiPickersUtilsProvider>
						</Grid>
						<Grid item>
							<StyledInput
								id="numberOfReleases"
								type={'number'}
								label={t('addBookNew.form.numberOfReleases')}
								onChange={handleChange}
								value={values.numberOfReleases}
								error={errors.numberOfReleases && touched.numberOfReleases}
							/>
						</Grid>
						<Grid item>
							<StyledInput
								id="numberOfSold"
								type={'number'}
								label={t('addBookNew.form.numberOfSold')}
								onChange={handleChange}
								value={values.numberOfSold}
								error={errors.numberOfSold && touched.numberOfSold}
							/>
						</Grid>
						<Grid item>
							<EditProfilePrizes
								values={values}
								fieldName={'prizes'}
								handleChange={handleChange}
								errors={errors}
								touched={touched}
							/>
						</Grid>
					</Grid>
				</BoxWrapper>
			</Grid>
		</Grid>
	);
}

interface Props {
	handleChange: any;
	setFieldValue: any;
	values: any;
	errors: any;
	touched: any;
}

const StyledLabel = styled('p')`
  color: ${Colors.neutral50};
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: -11px;
  line-height: 144%;
`;

const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
	.MuiOutlinedInput-root {
    border-radius: 12px;
    background-color: #fff;

    fieldset {
      border-color: ${Colors.neutral90};
    }

    &:hover {
      fieldset {
        box-shadow: 0 0 0 4px ${Colors.warning95};
        border-color: ${Colors.primary70};
      }
    }

    &.Mui-focused {
      fieldset {
        border: 1px solid ${Colors.primary70};
      }
    }

    &.Mui-error {
      fieldset {
        border-color: ${Colors.error20};
      }

      &:hover {
        fieldset {
          box-shadow: 0 0 0 4px #F2B8B5;
        }
      }
    }
  }
`;
